/**
 * @generated SignedSource<<e936284f79da1cc1e13ab79844723093>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type LessonAccess = "BOOKING" | "NONE" | "REQUEST";
import { FragmentRefs } from "relay-runtime";
export type useCurrentClubHasLessonsEnabled_session$data = {
  readonly currentClientProfile: {
    readonly member: {
      readonly club: {
        readonly facilities: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly privateLessonsPermissionSet: {
                readonly patronAccess: LessonAccess | null | undefined;
              } | null | undefined;
              readonly publicLessonsPermissionSet: {
                readonly patronAccess: LessonAccess | null | undefined;
              } | null | undefined;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly supportsPublic: boolean;
      };
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "useCurrentClubHasLessonsEnabled_session";
};
export type useCurrentClubHasLessonsEnabled_session$key = {
  readonly " $data"?: useCurrentClubHasLessonsEnabled_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"useCurrentClubHasLessonsEnabled_session">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "patronAccess",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useCurrentClubHasLessonsEnabled_session",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "currentClientProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "member",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Club",
              "kind": "LinkedField",
              "name": "club",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "supportsPublic",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FacilityConnection",
                  "kind": "LinkedField",
                  "name": "facilities",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "FacilityEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Facility",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "PublicLessonsPermissionSet",
                              "kind": "LinkedField",
                              "name": "publicLessonsPermissionSet",
                              "plural": false,
                              "selections": (v0/*: any*/),
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "PrivateLessonsPermissionSet",
                              "kind": "LinkedField",
                              "name": "privateLessonsPermissionSet",
                              "plural": false,
                              "selections": (v0/*: any*/),
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Session",
  "abstractKey": null
};
})();

(node as any).hash = "3e69d2ad4b6f7824737d72c166fd4a17";

export default node;
